import React, { FC } from 'react';
import styled from 'styled-components';

import BasicText, { ITextVariants } from '@ui/atoms/BasicText';
import FlexColumn from '@ui/atoms/FlexColumn';

import { IAddress } from '@folx-types/pharmacy';
import { SpacingTypes } from '@folx-types/theme';

interface IAddressTextProps extends IAddress {
	className?: string;
	gap?: SpacingTypes;
	variant?: ITextVariants;
}

const AddressText: FC<IAddressTextProps> = ({
	address,
	city,
	className,
	gap = 'none',
	state,
	variant = 'body',
	zip,
}) => {
	return (
		<FlexColumn gap={gap} className={className}>
			<BasicText variant={variant}>{address}</BasicText>
			<BasicText variant={variant}>
				{city}, {state} {zip}
			</BasicText>
		</FlexColumn>
	);
};

export default styled(AddressText)``;
